export default __webpack_public_path__ + "static/media/virtTechCampBg.40446821.jpg";